<template>
    <div id="detailScrollContainer">
        <div id="detailContainer" ref="detailContainer">
            <div id="detail">
                <div>
                    <div id="imageCont">
                        <div>
                            <img
                                class="image"
                                src="../assets/IMG_8833_web_dominic.jpg"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div id="bottom">
                <div id="bottomTop">
                    <div id="title">
                        <div id="titleText">
                            <span>Schützenstraße 39</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Menu from "@/components/Menu";
import { store } from "@/centralStore";
export default {
    name: "StudioImage",
    components: {
        Menu
    },
    data() {
        return {
            store: store.state
        };
    },
    methods: {},
    activated() {
        this.store.lastAbout = "studio-image";
        document.body.classList.add("index");
    },
    mounted() {
        document.body.classList.add("index");
    },
    beforeRouteLeave(to, from, next) {
        document.body.classList.remove("index");
        next();
    },
    beforeRouteUpdate(to, from, next) {
        document.body.classList.remove("index");
        next();
    }
};
</script>

<style scoped>
#detailScrollContainer {
    overflow: hidden;
    height: 100%;
    height: -webkit-fill-available;
    position: absolute;
    top: 0;
    width: 100%;
    /*background-color: rgba(0,0,0,0%);*/
    background-color: black;
}

#detailContainer {
    transition: margin 0.5s;
    position: relative;
    display: flex;
    flex-direction: column;
}
#detail {
    height: calc(var(--app-height) - 22rem);
    width: calc(100vw - 1rem);
    /*margin-top: 16px;
    margin-bottom: 15px;*/
    margin: 10.7rem 0.5rem 7.5rem;
    /*display: flex;*/
    /*flex-direction: column;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*cursor: pointer;*/
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    /*flex-direction: row;*/
    position: relative;
}
@media screen and (min-width: 768px) {
    #detail {
        margin: 4.4rem 0.5rem 1.6rem;
        height: calc(100vh - 8.5rem);
    }
}
@media screen and (min-width: 1000px) {
    #detail {
        margin: 6.9rem 0.5rem 4.6rem;
        height: calc(100vh - 14rem);
    }
}
#bottom {
    /*margin: 0 16px;*/
    margin: 0 1rem 0rem 0.9rem;
}
.image {
    max-width: 100%;
    max-height: 100%;
    /*max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);*/
}

#imageCont,
#preloaderCont {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    /*align-items: center;*/
}
#imageCont {
    align-items: center;
}
#imageCont > div {
    height: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    margin: 0 0.25rem;
}
#imageCont > div:first-child {
    margin-left: 0.5rem;
}
#imageCont > div:last-child {
    margin-right: 0.5rem;
}

#title {
    text-align: center;
}
</style>
